import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../wayfinder'
import auth from './auth'
/**
* @see \App\Http\Controllers\ZoteroController::page
* @see Http/Controllers/ZoteroController.php:29
* @route '/integrations/zotero'
*/
export const page = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: page.url(options),
    method: 'get',
})

page.definition = {
    methods: ["get","head"],
    url: '/integrations/zotero',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ZoteroController::page
* @see Http/Controllers/ZoteroController.php:29
* @route '/integrations/zotero'
*/
page.url = (options?: RouteQueryOptions) => {
    return page.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ZoteroController::page
* @see Http/Controllers/ZoteroController.php:29
* @route '/integrations/zotero'
*/
page.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: page.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ZoteroController::page
* @see Http/Controllers/ZoteroController.php:29
* @route '/integrations/zotero'
*/
page.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: page.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ZoteroController::page
* @see Http/Controllers/ZoteroController.php:29
* @route '/integrations/zotero'
*/
const pageForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: page.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ZoteroController::page
* @see Http/Controllers/ZoteroController.php:29
* @route '/integrations/zotero'
*/
pageForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: page.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ZoteroController::page
* @see Http/Controllers/ZoteroController.php:29
* @route '/integrations/zotero'
*/
pageForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: page.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

page.form = pageForm

/**
* @see \App\Http\Controllers\ZoteroController::status
* @see Http/Controllers/ZoteroController.php:116
* @route '/integrations/zotero/status'
*/
export const status = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: status.url(options),
    method: 'get',
})

status.definition = {
    methods: ["get","head"],
    url: '/integrations/zotero/status',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ZoteroController::status
* @see Http/Controllers/ZoteroController.php:116
* @route '/integrations/zotero/status'
*/
status.url = (options?: RouteQueryOptions) => {
    return status.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ZoteroController::status
* @see Http/Controllers/ZoteroController.php:116
* @route '/integrations/zotero/status'
*/
status.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: status.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ZoteroController::status
* @see Http/Controllers/ZoteroController.php:116
* @route '/integrations/zotero/status'
*/
status.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: status.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ZoteroController::status
* @see Http/Controllers/ZoteroController.php:116
* @route '/integrations/zotero/status'
*/
const statusForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: status.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ZoteroController::status
* @see Http/Controllers/ZoteroController.php:116
* @route '/integrations/zotero/status'
*/
statusForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: status.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ZoteroController::status
* @see Http/Controllers/ZoteroController.php:116
* @route '/integrations/zotero/status'
*/
statusForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: status.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

status.form = statusForm

/**
* @see \App\Http\Controllers\ZoteroController::collections
* @see Http/Controllers/ZoteroController.php:135
* @route '/integrations/zotero/collections'
*/
export const collections = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: collections.url(options),
    method: 'get',
})

collections.definition = {
    methods: ["get","head"],
    url: '/integrations/zotero/collections',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ZoteroController::collections
* @see Http/Controllers/ZoteroController.php:135
* @route '/integrations/zotero/collections'
*/
collections.url = (options?: RouteQueryOptions) => {
    return collections.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ZoteroController::collections
* @see Http/Controllers/ZoteroController.php:135
* @route '/integrations/zotero/collections'
*/
collections.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: collections.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ZoteroController::collections
* @see Http/Controllers/ZoteroController.php:135
* @route '/integrations/zotero/collections'
*/
collections.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: collections.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ZoteroController::collections
* @see Http/Controllers/ZoteroController.php:135
* @route '/integrations/zotero/collections'
*/
const collectionsForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: collections.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ZoteroController::collections
* @see Http/Controllers/ZoteroController.php:135
* @route '/integrations/zotero/collections'
*/
collectionsForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: collections.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ZoteroController::collections
* @see Http/Controllers/ZoteroController.php:135
* @route '/integrations/zotero/collections'
*/
collectionsForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: collections.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

collections.form = collectionsForm

/**
* @see \App\Http\Controllers\ZoteroController::groups
* @see Http/Controllers/ZoteroController.php:156
* @route '/integrations/zotero/groups'
*/
export const groups = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: groups.url(options),
    method: 'get',
})

groups.definition = {
    methods: ["get","head"],
    url: '/integrations/zotero/groups',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ZoteroController::groups
* @see Http/Controllers/ZoteroController.php:156
* @route '/integrations/zotero/groups'
*/
groups.url = (options?: RouteQueryOptions) => {
    return groups.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ZoteroController::groups
* @see Http/Controllers/ZoteroController.php:156
* @route '/integrations/zotero/groups'
*/
groups.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: groups.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ZoteroController::groups
* @see Http/Controllers/ZoteroController.php:156
* @route '/integrations/zotero/groups'
*/
groups.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: groups.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ZoteroController::groups
* @see Http/Controllers/ZoteroController.php:156
* @route '/integrations/zotero/groups'
*/
const groupsForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: groups.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ZoteroController::groups
* @see Http/Controllers/ZoteroController.php:156
* @route '/integrations/zotero/groups'
*/
groupsForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: groups.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ZoteroController::groups
* @see Http/Controllers/ZoteroController.php:156
* @route '/integrations/zotero/groups'
*/
groupsForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: groups.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

groups.form = groupsForm

/**
* @see \App\Http\Controllers\ZoteroController::items
* @see Http/Controllers/ZoteroController.php:177
* @route '/integrations/zotero/items'
*/
export const items = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: items.url(options),
    method: 'get',
})

items.definition = {
    methods: ["get","head"],
    url: '/integrations/zotero/items',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ZoteroController::items
* @see Http/Controllers/ZoteroController.php:177
* @route '/integrations/zotero/items'
*/
items.url = (options?: RouteQueryOptions) => {
    return items.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ZoteroController::items
* @see Http/Controllers/ZoteroController.php:177
* @route '/integrations/zotero/items'
*/
items.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: items.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ZoteroController::items
* @see Http/Controllers/ZoteroController.php:177
* @route '/integrations/zotero/items'
*/
items.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: items.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ZoteroController::items
* @see Http/Controllers/ZoteroController.php:177
* @route '/integrations/zotero/items'
*/
const itemsForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: items.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ZoteroController::items
* @see Http/Controllers/ZoteroController.php:177
* @route '/integrations/zotero/items'
*/
itemsForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: items.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ZoteroController::items
* @see Http/Controllers/ZoteroController.php:177
* @route '/integrations/zotero/items'
*/
itemsForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: items.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

items.form = itemsForm

/**
* @see \App\Http\Controllers\ZoteroController::importMethod
* @see Http/Controllers/ZoteroController.php:210
* @route '/integrations/zotero/import'
*/
export const importMethod = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: importMethod.url(options),
    method: 'post',
})

importMethod.definition = {
    methods: ["post"],
    url: '/integrations/zotero/import',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ZoteroController::importMethod
* @see Http/Controllers/ZoteroController.php:210
* @route '/integrations/zotero/import'
*/
importMethod.url = (options?: RouteQueryOptions) => {
    return importMethod.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ZoteroController::importMethod
* @see Http/Controllers/ZoteroController.php:210
* @route '/integrations/zotero/import'
*/
importMethod.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: importMethod.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ZoteroController::importMethod
* @see Http/Controllers/ZoteroController.php:210
* @route '/integrations/zotero/import'
*/
const importMethodForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: importMethod.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ZoteroController::importMethod
* @see Http/Controllers/ZoteroController.php:210
* @route '/integrations/zotero/import'
*/
importMethodForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: importMethod.url(options),
    method: 'post',
})

importMethod.form = importMethodForm

/**
* @see \App\Http\Controllers\ZoteroController::disconnect
* @see Http/Controllers/ZoteroController.php:247
* @route '/integrations/zotero/disconnect'
*/
export const disconnect = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: disconnect.url(options),
    method: 'post',
})

disconnect.definition = {
    methods: ["post"],
    url: '/integrations/zotero/disconnect',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ZoteroController::disconnect
* @see Http/Controllers/ZoteroController.php:247
* @route '/integrations/zotero/disconnect'
*/
disconnect.url = (options?: RouteQueryOptions) => {
    return disconnect.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ZoteroController::disconnect
* @see Http/Controllers/ZoteroController.php:247
* @route '/integrations/zotero/disconnect'
*/
disconnect.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: disconnect.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ZoteroController::disconnect
* @see Http/Controllers/ZoteroController.php:247
* @route '/integrations/zotero/disconnect'
*/
const disconnectForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: disconnect.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ZoteroController::disconnect
* @see Http/Controllers/ZoteroController.php:247
* @route '/integrations/zotero/disconnect'
*/
disconnectForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: disconnect.url(options),
    method: 'post',
})

disconnect.form = disconnectForm

const zotero = {
    page: Object.assign(page, page),
    auth: Object.assign(auth, auth),
    status: Object.assign(status, status),
    collections: Object.assign(collections, collections),
    groups: Object.assign(groups, groups),
    items: Object.assign(items, items),
    import: Object.assign(importMethod, importMethod),
    disconnect: Object.assign(disconnect, disconnect),
}

export default zotero